import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useStoreApi } from '../../hooks/useStoreApi';
import { useSnackbar } from '../Stateless/SnackBarProvider';
type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeType?:string;
  merchantId?:string
};

export const useAllStores = (queryParams: Params) => {
  const { getAllStores } = useStoreApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getStore',queryParams],
    queryFn: () => {
      return getAllStores(queryParams);
    },
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

export const UseCreateStores = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createStores } = useStoreApi();
  return useMutation({
    mutationKey: ['CreateStore'],
    mutationFn: (data: any) => createStores(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Store created successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create Store',
        'error'
      );
    },
  });
};

export const usePatchStore = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useStoreApi();

  return useMutation({
    mutationKey: ['PatchSubAdmin'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === 'unblocked' ? 'unblocked' : 'blocked';
      showMessage(`Store ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type || 'Failed to block the Store',
        'error'
      );
    },
  });
};
export const useDeleteStore = () => {
  const queryClient = useQueryClient();
  const { deleteStore } = useStoreApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteSubAdmin'],
    mutationFn: (ids: string[]) => {
      return deleteStore(ids);
    },
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Store deleted successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted Store',
        'error'
      );
    },
  });
};

export const useEditStore = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editStore } = useStoreApi();

  return useMutation({
    mutationKey: ['EditStore'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editStore(id, data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Store Updated successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['getStore'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to update the SubAdmin',
        'error'
      );
    },
  });
};
